import React, { FC, useMemo } from 'react';
import { SocialNetwork, getSocialLinksInstance } from '@okletsplay/core';
import { Tooltip, useTheme } from '@mui/material';
import { toastSuccess } from 'modules/utils';
import { SOCIAL_NETWORK_ICONS } from 'app/constants';

const socialLinks = getSocialLinksInstance();

interface SocialLinkProps {
  network: SocialNetwork;
  link: string;
}

const AUTO_CLOSE_TOAST_TIMEOUT_MS = 30 * 1000;

export const SocialNetworkLink: FC<SocialLinkProps> = ({ network, link }) => {
  const theme = useTheme();

  const href = useMemo(() => {
    return socialLinks.buildLink(network, link);
  }, [link, network]);

  const onClickForCopyableLink = (e: React.MouseEvent) => {
    e.preventDefault();
    navigator.clipboard.writeText(link);
    toastSuccess(`"${link}" copied to clipboard`, { autoClose: AUTO_CLOSE_TOAST_TIMEOUT_MS });
  };

  const icon = (
    <img src={SOCIAL_NETWORK_ICONS[network]} width={theme.spacing(4)} alt={network.toString()} />
  );

  if (network === SocialNetwork.Discord) {
    return (
      <Tooltip title={link}>
        <a onClick={onClickForCopyableLink} href="#">
          {icon}
        </a>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={href}>
      <a href={href} target="_blank" rel="noreferrer">
        {icon}
      </a>
    </Tooltip>
  );
};
